import { icons } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import newExcel from "../../../assets/images/newExcel.svg";
export var getColumns = function (reportType) {
    switch (reportType) {
        case "balance-aging":
            return [
                { field: "certificado", headerName: "Certificado", width: 200 },
                { field: "primerNombre", headerName: "Primer nombre", width: 180 },
                { field: "segundoNombre", headerName: "Segundo nombre", width: 180 },
                { field: "primerApellido", headerName: "Primer apellido", width: 180 },
                { field: "segundoApellido", headerName: "Segundo apellido", width: 180 },
                { field: "cedula", headerName: "Cedula", width: 160 },
                { field: "cuenta", headerName: "Cuenta", width: 160 },
                { field: "tipoCuenta", headerName: "Tipo de cuenta", width: 200 },
                { field: "fechaEfectiva", headerName: "Fecha efectiva", width: 180 },
                { field: "prima", headerName: "Prima", width: 140 },
                { field: "formaPago", headerName: "Forma pago", width: 160 },
                { field: "cuotasPendientes", headerName: "Cuotas pendientes", width: 180 },
                { field: "descripcionProducto", headerName: "Descripción producto", width: 260 },
                { field: "ultimoPeriodoFacturado", headerName: "Ultimo periodo facturado", width: 220 },
                { field: "rango1_30", headerName: "1-30", width: 100 },
                { field: "rango31_60", headerName: "31-60", width: 100 },
                { field: "rango61_90", headerName: "61-90", width: 100 },
                { field: "polizaProtegida", headerName: "Poliza protegida", width: 180 },
            ];
        case "upcoming-cancellations":
            return [
                { field: "certificado", headerName: "No. de certificado", width: 200 },
                { field: "nombreProducto", headerName: "Nombre del producto de Banca Seguros", width: 300 },
                { field: "fechaEmision", headerName: "Fecha de emisión", width: 180 },
                { field: "nombre", headerName: "Nombre", width: 180 },
                { field: "apellido", headerName: "Apellido", width: 200 },
                { field: "cedula", headerName: "Cédula del cliente", width: 180 },
                { field: "nombreProductoApap", headerName: "Nombre del producto de APAP", width: 260 },
                { field: "noProductoApap", headerName: "No. Producto APAP", width: 180 },
                { field: "prima", headerName: "Prima", width: 140 },
                { field: "modalidadPago", headerName: "Modalidad de pago", width: 180 },
                { field: "estado", headerName: "Estado", width: 130 },
                { field: "nombreEmpleado", headerName: "Nombre del empleado", width: 230 },
                { field: "posicionEmpleado", headerName: "Posición de empleado", width: 200 },
                { field: "usuario", headerName: "Usuario", width: 160 },
                { field: "sucursal", headerName: "Sucursal", width: 160 },
            ];
        case "health-preferential":
            return [
                { field: "noCertificado", headerName: "No. de Certificado", width: 200 },
                { field: "nombreProductoBanca", headerName: "Nombre del producto de Banca Seguros", width: 300 },
                { field: "fechaEmision", headerName: "Fecha de Emisión", width: 180 },
                { field: "fechaActualizacion", headerName: "Fecha de actualización", width: 200 },
                { field: "tipoActualizacion", headerName: "Tipo de actualización", width: 190 },
                { field: "tipoAsegurado", headerName: "Tipo de asegurado", width: 180 },
                { field: "nombre", headerName: "Nombre", width: 180 },
                { field: "apellido", headerName: "Apellido", width: 200 },
                { field: "cedula", headerName: "Cédula del cliente", width: 180 },
                { field: "nombreProductoApap", headerName: "Nombre del producto APAP", width: 250 },
                { field: "noProductoPrima", headerName: "No. Producto a cargar la prima", width: 260 },
                { field: "prima", headerName: "Prima", width: 140 },
                { field: "estado", headerName: "Estado", width: 130 },
                { field: "nombreEmpleado", headerName: "Nombre del empleado", width: 220 },
                { field: "usuario", headerName: "Usuario", width: 160 },
                { field: "sucursal", headerName: "Sucursal", width: 140 },
                { field: "fechaCancelacion", headerName: "Fecha de Cancelación", width: 200 },
                { field: "motivoCancelacion", headerName: "Motivo de Cancelación", width: 220 },
            ];
        case "travel-assistance":
            return [
                { field: "on", headerName: "ON", width: 180 },
                { field: "fecha", headerName: "Fecha", width: 160 },
                { field: "noVoucher", headerName: "No. Voucher", width: 180 },
                { field: "nombre", headerName: "Nombre", width: 180 },
                { field: "apellido", headerName: "Apellido", width: 180 },
                { field: "fechaNacimiento", headerName: "Fecha Nacimiento", width: 180 },
                { field: "telefono", headerName: "Teléfono", width: 160 },
                { field: "correo", headerName: "Correo", width: 220 },
                { field: "cedula", headerName: "Cedula", width: 160 },
                { field: "noPasajeros", headerName: "No. Pasajeros", width: 150 },
                { field: "fechaSalida", headerName: "Fecha Salida", width: 160 },
                { field: "fechaRegreso", headerName: "Fecha Regreso", width: 160 },
                { field: "status", headerName: "Status", width: 120 },
                { field: "noReferencia", headerName: "No. Referencia", width: 180 },
                { field: "tipoCuenta", headerName: "Tipo de Cuenta", width: 200 },
                { field: "noCuenta", headerName: "No. Cuenta", width: 180 },
                { field: "montoPrimaUSD", headerName: "Monto Prima USD", width: 180 },
                { field: "montoPrimaRD", headerName: "Monto Prima RD$", width: 180 },
                { field: "tasa", headerName: "Tasa", width: 120 },
            ];
        case "first-fee":
            return [
                { field: "poliza", headerName: "Póliza", width: 180 },
                { field: "nombre", headerName: "Nombre", width: 200 },
                { field: "primerApellido", headerName: "Primer Apellido", width: 200 },
                { field: "segundoApellido", headerName: "Segundo Apellido", width: 200 },
                { field: "secuencia", headerName: "Secuencia", width: 140 },
                { field: "cuenta", headerName: "Cuenta", width: 200 },
                { field: "tipoCuenta", headerName: "Tipo Cuenta", width: 200 },
                { field: "fechaEfectiva", headerName: "Fecha Efectiva", width: 180 },
                { field: "monto", headerName: "Monto", width: 160 },
                { field: "producto", headerName: "Producto", width: 200 },
                { field: "codigoTransaccion", headerName: "Código Transacción", width: 220 },
            ];
        default: // "sales"
            return [
                { field: "certificate", headerName: "No. certificado", width: 190 },
                { field: "product", headerName: "Producto", width: 175 },
                { field: "creationDate", headerName: "Fecha de emisión", width: 180 },
                { field: "names", headerName: "Nombres", width: 250 },
                { field: "lastNames", headerName: "Apellidos", width: 250 },
                { field: "identificationNumber", headerName: "Cédula del cliente", width: 220 },
                { field: "paymentType", headerName: "Tipo de cuenta", width: 300 },
                { field: "accountNumber", headerName: "Numero de cuenta", width: 320 },
                { field: "prime", headerName: "Prima", width: 160 },
                { field: "status", headerName: "Estado", width: 130 },
                { field: "userName", headerName: "Nombre del empleado", width: 250 },
                { field: "user", headerName: "Usuario", width: 160 },
                { field: "branch", headerName: "Sucursal", width: 160 },
                { field: "cancellationDate", headerName: "Fecha de cancelación", width: 250 },
                { field: "reasonCancellation", headerName: "Motivo de cancelación", width: 270 },
            ];
    }
};
export var getExportConfig = function (reportType) {
    switch (reportType) {
        case "balance-aging":
            return {
                fields: "Certificado,Nombre,Primer Apellido,Segundo Apellido,Cedula,Cuenta,Tipo de Cuenta,Fecha Efectiva,Prima,Forma Pago,Cuotas Pendientes,Descripcion Producto,Ultimo Periodo Facturado,1-30,31-60,61-90,Poliza Protegida",
                labelFields: "Certificado,Primer nombre,Primer apellido,Segundo apellido,Cedula,Cuenta,Tipo de cuenta,Fecha efectiva,Prima,Forma pago,Cuotas pendientes,Descripción producto,Ultimo periodo facturado,1-30,31-60,61-90,Poliza protegida",
            };
        case "upcoming-cancellations":
            return {
                fields: "Certificado,Nombre Producto,Fecha Emision,Nombre,Apellido,Cedula Cliente,Nombre Producto APAP,No Producto APAP,Prima,Modalidad Pago,Desc Estatus,Nombre Empleado,Posicion Empleado,Usuario,Sucursal",
                labelFields: "No. de certificado,Nombre del producto de Banca Seguros,Fecha de emisión,Nombre,Apellido,Cédula del cliente,Nombre del producto de APAP,No. Producto APAP,Prima,Modalidad de pago,Estado,Nombre del empleado,Posición de empleado,Usuario,Sucursal",
            };
        case "health-preferential":
            return {
                fields: "polizaid,descripcion,fechaefectiva,fechaaccionusuario,tipoactualizacion,tipoasegurado,nombre,apellido,nodocumento,descripcion,nocuenta,premium,estado,nombreempleado,usuario,sucursal,fechacancelacion,motivocancelacion",
                labelFields: "No. de Certificado,Nombre del producto de Banca Seguros,Fecha de Emisión,Fecha de actualización,Tipo de actualización,Tipo de asegurado,Nombre,Apellido,Cédula del cliente,Nombre del producto APAP,No. Producto a cargar la prima,Prima,Estado,Nombre del empleado,Usuario,Sucursal,Fecha de Cancelación,Motivo de Cancelación",
            };
        case "travel-assistance":
            return {
                fields: "polizaid,fechaefectiva,voucher,nombrea,apellidoa,fechanacimiento,telefonocasa,correoelectronico,secuencia,nopasajeros,startdate,enddate,cnfestatuspolizaid,descriptionshort,numberaccount,premium,primiunpesos,exchangerate",
                labelFields: "ON,Fecha,No. Voucher,Nombre,Apellido,Fecha Nacimiento,Teléfono,Correo,Cedula,No. Pasajeros,Fecha Salida,Fecha Regreso,Status,Tipo de Cuenta,No. Cuenta,Monto Prima USD,Monto Prima RD$,Tasa",
            };
        case "first-fee":
            return {
                fields: "PolizaId,NombreA,ApellidoA,ApellidoB,Secuencia,NumeroCuenta,TipoCuenta,FechaEfectiva,Monto,Producto,CodigoTransaccion",
                labelFields: "Póliza,Nombre,Primer Apellido,Segundo Apellido,Secuencia,Cuenta,Tipo Cuenta,Fecha Efectiva,Monto,Producto,Código Transacción",
            };
        default: // "sales"
            return {
                fields: "policyId.code,code,productId.description,policyId.effectiveFrom,creationDate,firstNameA,firstNameB,lastNameA,lastNameB,numberId,customerAccount.accountType.description,customerAccount.accountNumber,customerAccount.amount,catalogStatusQuote.description,user.fullName,user.email,clientId.description,catalogCancellation.createdAt,catalogCancellation.description",
                labelFields: "Póliza,Cotización,Producto,Fecha efectiva,Póliza creada el,Primer nombre,Segundo nombre,Primer apellido,Segundo apellido,No. Documento,Tipo de cuenta,No. de cuenta,Prima,Estado,Nombre del empleado,Usuario,Aseguradora,Fecha de cancelación,Motivo de cancelación",
            };
    }
};
export var getReportTitle = function (reportType) {
    switch (reportType) {
        case "balance-aging":
            return "Saldo por Antigüedad";
        case "upcoming-cancellations":
            return "Próximas a Cancelar";
        case "health-preferential":
            return "Movimientos Salud Preferencial";
        case "travel-assistance":
            return "Asistencia al Viajero";
        case "first-fee":
            return "Primera Cuota";
        default:
            return "Ventas";
    }
};
export var buttonActionOptions = [
    {
        icons: icons.DownloadForOffline,
        id: "1",
        img: newExcel,
        name: "Descargar Excel",
    },
];
